import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import commonPropTypes from '../../../constants/commonPropTypes';
import { formFieldWrapper } from '../formFieldWrapper';
import StandardFieldLabel from '../formFieldWrapper/standardFieldLabel';
import PendingTooltip from '../formFieldWrapper/pendingTooltip';
import styles from './styles.scss';
const cx = classnames.bind(styles);
export const roles = ['action', 'info', 'success', 'caution', 'error'];
class BaseCheckboxField extends Component {
    static propTypes = {
        ...commonPropTypes,
        toggle: PropTypes.bool,
        checkboxLabel: PropTypes.node,
        role: PropTypes.oneOf(roles),
        size: PropTypes.string,
        valueAsArray: PropTypes.bool,
        showAnchor: PropTypes.bool,
        helpContent: PropTypes.node,
    };
    static defaultProps = {
        className: '',
        elmId: 'base_checkbox_field',
        compact: true,
    };
    render() {
        const { checkboxLabel, className, elmId, onChange, role = roles[0], onBlur, showError, compact, viewMode, size, value, toggle, label, valueAsArray = false, showAnchor, helpContent, pendingApproval, ...rest } = this.props;
        let newCompact = compact;
        if (typeof this.props.size !== 'undefined') {
            newCompact = size === 'small';
        }
        const labelProps = {
            checkboxType: 'checkbox',
            compact: newCompact,
            className,
            elmId,
            showAnchor,
            helpContent,
        };
        const newLabel = checkboxLabel || StandardFieldLabel.createFromLabel(label, labelProps);
        const defaultCheckboxClassNames = [
            'rtc-checkbox',
            !newCompact ? 'ch-md' : '',
            !(label || checkboxLabel) ? 'no-label' : '',
            className,
            _.kebabCase(role),
        ];
        const classNames = toggle ? [className] : defaultCheckboxClassNames;
        const newOnChange = (e, data) => {
            if (valueAsArray && typeof data.value === 'string') {
                data.value = data.value.split(',');
            }
            onChange(e, data);
        };
        const newValue = valueAsArray
            ? Array.isArray(value) && value.join(',')
            : value;
        return (_jsxs("div", { className: cx('wrapper'), children: [pendingApproval && _jsx(PendingTooltip, { style: { padding: '3px 0' } }), _jsx(Checkbox, { "data-elm-id": `${elmId}_checkbox`, "aria-label": `${elmId}_checkbox`, className: cx(...classNames), toggle: toggle, label: newLabel, onBlur: onBlur, onChange: newOnChange, value: newValue, ...rest })] }));
    }
}
export default formFieldWrapper((fieldProps, showError) => (_jsx(BaseCheckboxField, { ...fieldProps, showError: showError })));
//# sourceMappingURL=index.js.map